import { ProfileCalendar } from "PFApp/booking/types";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import React from "react";

import bookingCalendarCss from "../../../booking_calendars.module.scss";
import css from "../workforce.module.scss";

type StartDatesCellProps = {
  startDates: ProfileCalendar[];
};

export const StartDatesCell = ({ startDates }: StartDatesCellProps) => {
  const { formatDate } = useDateFormatter();

  return (
    <div className={bookingCalendarCss.calendarsGridCell}>
      {startDates.map((date) => (
        <div key={date.id} className={css.cellEntry}>
          {formatDate(date.start_date)}
        </div>
      ))}
    </div>
  );
};
